const DATE = /^\d{4}-\d{2}-\d{2}$/;
const MAX_HOLIDAYS = 60;

/** Reads a list of holidays written as dates "YYYY-MM-DD" separated by spaces, commas or lines. Returns them sorted without repeats (empty text is an empty list), or null when one is not a real date or there are more than 60. */
export function parseHolidays(text: string): string[] | null {
  const dates = [...new Set(text.split(/[\s,]+/).filter(Boolean))].sort();
  const real = (d: string) => DATE.test(d) && !Number.isNaN(Date.parse(d)) && new Date(d).toISOString().startsWith(d);
  return dates.length <= MAX_HOLIDAYS && dates.every(real) ? dates : null;
}
